export default "__VITE_ASSET__CdftPDSM__"